import { render } from "./iteminput.vue?vue&type=template&id=25c84a93&scoped=true"
import script from "./iteminput.vue?vue&type=script&lang=js"
export * from "./iteminput.vue?vue&type=script&lang=js"

import "./iteminput.vue?vue&type=style&index=0&id=25c84a93&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c84a93"]])

export default __exports__